import { BigNumber } from '@xylabs/bignumber'
import { EthAddress } from '@xylabs/sdk-js'

import { XyoWorldBase } from '../../../../Base'
import { Quadkey } from '../../../../Quadkey'
import { AuctionStatus } from '../Status'
import { StaticAuctionJsonObject } from './JsonObject'

export class StaticData extends XyoWorldBase<StaticAuctionJsonObject> {
  auctionLength?: number

  buyer?: EthAddress

  cost?: BigNumber

  endTime?: number

  hasBid?: boolean

  minted?: boolean

  minter?: EthAddress

  mintingReward?: BigNumber

  quadkey: Quadkey

  startBlock?: number

  startTime?: number

  started?: boolean

  startingBid?: BigNumber

  constructor(quadkey: Quadkey, jsonObject?: StaticAuctionJsonObject) {
    super()
    this.quadkey = quadkey
    this.loadJsonObject(jsonObject ?? {})
  }

  public isCompleted() {
    return this.isExpired() && !!this.hasBid && !this.minted
  }

  public isDutch() {
    return this.isExpired() && !this.hasBid && !this.minted
  }

  public isExpired() {
    return this.minted || this.endTime ? (this.endTime ?? 0) < Date.now() / 1000 : false
  }

  public isLive() {
    return this.started && !this.isExpired() && !this.minted
  }

  public isMinted() {
    return !!this.minted
  }

  public isUpcoming() {
    return !this.started && !this.minted
  }

  public loadJsonObject(jsonObject?: StaticAuctionJsonObject) {
    if (jsonObject) {
      this.buyer = EthAddress.parse(jsonObject.buyer)
      this.cost = jsonObject.cost ? new BigNumber(jsonObject.cost) : undefined
      this.startingBid = jsonObject.startingBid ? new BigNumber(jsonObject.startingBid) : undefined
      this.endTime = jsonObject.endTime
      this.startTime = jsonObject.startTime
      this.auctionLength = jsonObject.auctionLength
      this.startBlock = jsonObject.startBlock
      this.hasBid = jsonObject.hasBid
      this.minted = jsonObject.minted
      this.minter = EthAddress.parse(jsonObject.minter)
      this.mintingReward = jsonObject.mintingReward ? new BigNumber(jsonObject.mintingReward) : undefined
      this.started = jsonObject.started
    }
    this.checkFhr()
    return this
  }

  public status(): AuctionStatus {
    if (this.isUpcoming()) return AuctionStatus.Upcoming
    if (this.isLive()) return AuctionStatus.Live
    if (this.isDutch()) return AuctionStatus.Dutch
    if (this.isCompleted()) return AuctionStatus.Completed
    if (this.isMinted()) return AuctionStatus.Minted
    return AuctionStatus.Unknown
  }

  public toJsonObject(): StaticAuctionJsonObject {
    const result: StaticAuctionJsonObject = {}
    if (this.started) result.started = this.started
    if (this.hasBid) result.hasBid = this.hasBid
    if (this.minted) result.minted = this.minted
    if (this.cost) result.cost = this.cost.toString(10)
    if (this.startingBid) result.startingBid = this.startingBid.toString(10)
    if (this.buyer) result.buyer = this.buyer.toString()
    if (this.minter) result.minter = this.minter.toString()
    if (this.endTime) result.endTime = this.endTime
    if (this.startTime) result.startTime = this.startTime
    if (this.auctionLength) result.auctionLength = this.auctionLength
    if (this.startBlock) result.startBlock = this.startBlock
    if (this.mintingReward) result.mintingReward = this.mintingReward.toString(10)
    return result
  }

  private checkFhr() {
    if (this.quadkey.equals(Quadkey.root)) {
      this.minted = true
      this.started = true
      this.hasBid = true
      this.endTime = 1
    }
  }
}
